// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Upload.css - Dark Theme to match DemoDashboard */

body {
  background: linear-gradient(to bottom right, #2b2b2b 0%, #141414 50%, #000000 100%);
  min-height: 100vh;
}

.file-selection-view,
.protection-setup-view,
.upload-progress-view,
.upload-results-view {
  color: white;
  background: transparent;
}

.upload-header {
  text-align: center;
  margin-bottom: 32px;
}

.upload-header .header-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.upload-header h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #a78bfa;
}

.upload-header p {
  color: #d1d5db;
  font-size: 16px;
}

.info-box {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
  backdrop-filter: blur(10px);
}

.info-box h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: white;
}

.info-items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #d1d5db;
  font-size: 14px;
}

.info-item .info-icon {
  font-size: 24px;
}

.drop-zone {
  border: 2px dashed rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  padding: 48px 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(0, 0, 0, 0.3);
  margin-bottom: 24px;
  backdrop-filter: blur(10px);
}

.drop-zone:hover {
  border-color: rgba(168, 85, 247, 0.5);
  background: rgba(168, 85, 247, 0.05);
  transform: translateY(-2px);
}

.drop-zone.dragging {
  border-color: #a855f7;
  background: rgba(168, 85, 247, 0.15);
  box-shadow: 0 8px 32px rgba(168, 85, 247, 0.2);
}

.drop-zone-content .drop-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.drop-zone-content h3 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
  color: white;
}

.drop-zone-content p {
  color: #9ca3af;
  margin-bottom: 4px;
}

.drop-zone-content .drop-hint {
  font-size: 14px;
  color: #6b7280;
}

.selected-files .files-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  color: white;
  font-weight: 600;
}

.clear-btn {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.3);
  padding: 6px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.clear-btn:hover {
  background: rgba(239, 68, 68, 0.2);
}

.files-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.file-item {
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(5px);
}

.file-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.file-item.active {
  border-color: #a855f7;
  background: rgba(168, 85, 247, 0.15);
  box-shadow: 0 4px 16px rgba(168, 85, 247, 0.2);
}

.file-preview {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.03);
  margin-bottom: 8px;
}

.file-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.file-icon {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
}

.remove-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.9);
  color: white;
  border: none;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.remove-btn:hover {
  background: #dc2626;
  transform: scale(1.1);
}

.file-name {
  font-size: 13px;
  color: white;
  font-weight: 500;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  font-size: 12px;
  color: #9ca3af;
}

.edit-btn {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  border: 1px solid rgba(59, 130, 246, 0.3);
  padding: 4px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
}

.edit-btn:hover {
  background: rgba(59, 130, 246, 0.2);
}

.add-more {
  color: #3b82f6;
  font-size: 14px;
  cursor: pointer;
  margin-top: 12px;
}

.add-more:hover {
  text-decoration: underline;
}

.file-info {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 24px;
  backdrop-filter: blur(10px);
}

.file-info p {
  color: #d1d5db;
  font-size: 14px;
  margin: 4px 0;
}

.btn-upload {
  width: 100%;
  background: linear-gradient(135deg, #a855f7 0%, #3b82f6 100%);
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(168, 85, 247, 0.3);
}

.btn-upload:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(168, 85, 247, 0.4);
}

.protection-setup-view h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #a78bfa;
  text-align: center;
}

.protection-setup-view .header-icon {
  text-align: center;
  font-size: 48px;
  margin-bottom: 16px;
}

.subtitle {
  text-align: center;
  color: #d1d5db;
  font-size: 16px;
  margin-bottom: 32px;
  margin-top: -4px;
}

.protection-type-tabs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 32px;
}

.protection-tab {
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 16px;
  backdrop-filter: blur(10px);
}

.protection-tab:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(59, 130, 246, 0.4);
  transform: translateY(-2px);
}

.protection-tab.active {
  background: rgba(59, 130, 246, 0.15);
  border-color: #3b82f6;
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.2);
}

.tab-icon {
  font-size: 48px;
}

.tab-content h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
  color: white;
}

.tab-content p {
  font-size: 14px;
  color: #9ca3af;
}

.preview-container {
  margin: 32px 0;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 24px;
  backdrop-filter: blur(10px);
}

.preview-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 32px;
  color: #9ca3af;
}

.preview-placeholder span {
  font-size: 64px;
  margin-bottom: 16px;
}

.preview-placeholder p {
  font-size: 16px;
  margin: 4px 0;
}

.placeholder-hint {
  font-size: 14px !important;
  color: #6b7280 !important;
}

.option-group {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  backdrop-filter: blur(10px);
}

.option-group h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: white;
}

.option-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.option-header h3 {
  margin-bottom: 0;
}

.option-header span {
  color: #3b82f6;
  font-weight: 600;
}

.position-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 12px;
}

.position-btn {
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  backdrop-filter: blur(5px);
}

.position-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.position-btn.selected {
  background: rgba(59, 130, 246, 0.2);
  border-color: #3b82f6;
  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.3);
}

.position-icon {
  font-size: 32px;
}

.position-label {
  font-size: 13px;
  color: #d1d5db;
}

.slider {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  outline: none;
  margin: 16px 0;
}

.slider::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #a855f7 0%, #3b82f6 100%);
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(168, 85, 247, 0.4);
}

.slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #a855f7 0%, #3b82f6 100%);
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 8px rgba(168, 85, 247, 0.4);
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #9ca3af;
  margin-top: 8px;
}

.helper-text {
  font-size: 14px;
  color: #9ca3af;
  margin-top: 8px;
}

.error-correction-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 12px;
}

.ec-btn {
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: white;
  backdrop-filter: blur(5px);
}

.ec-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.ec-btn.selected {
  background: rgba(59, 130, 246, 0.2);
  border-color: #3b82f6;
  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.3);
}

.ec-level {
  font-size: 12px;
  color: #9ca3af;
}

.color-selection {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.color-btn {
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 16px;
  backdrop-filter: blur(10px);
}

.color-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.color-btn.selected {
  background: rgba(59, 130, 246, 0.2);
  border-color: #3b82f6;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
}

.color-preview {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
}

.color-preview.white {
  background: white;
  color: black;
}

.color-preview.black {
  background: black;
  color: white;
}

.color-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.color-name {
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.color-desc {
  font-size: 13px;
  color: #9ca3af;
}

.protection-summary {
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.3);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
}

.protection-summary h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #10b981;
}

.summary-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.summary-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.summary-icon {
  font-size: 24px;
}

.summary-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.summary-content strong {
  color: white;
  font-size: 15px;
}

.summary-content span {
  color: #d1d5db;
  font-size: 13px;
}

.protection-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.btn-primary {
  flex: 1 1;
  min-width: 200px;
  background: linear-gradient(135deg, #a855f7 0%, #3b82f6 100%);
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(168, 85, 247, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(168, 85, 247, 0.4);
}

.btn-secondary {
  flex: 1 1;
  min-width: 200px;
  background: rgba(255, 255, 255, 0.05);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
}

.upload-progress-view {
  text-align: center;
  padding: 64px 32px;
}

.progress-icon {
  font-size: 64px;
  margin-bottom: 24px;
}

.upload-progress-view h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #a78bfa;
}

.status-text {
  color: #d1d5db;
  font-size: 16px;
  margin-bottom: 24px;
}

.progress-bar-container {
  width: 100%;
  max-width: 500px;
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  overflow: hidden;
  margin: 0 auto 16px;
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #a855f7 0%, #3b82f6 100%);
  transition: width 0.3s ease;
  border-radius: 6px;
}

.progress-text {
  color: #3b82f6;
  font-size: 18px;
  font-weight: 600;
}

.upload-results-view {
  padding: 32px;
}

.results-header {
  text-align: center;
  margin-bottom: 32px;
}

.results-header h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #a78bfa;
}

.results-header p {
  color: #d1d5db;
  font-size: 16px;
}

.results-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 16px;
  margin-bottom: 32px;
}

.result-card {
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 20px;
  backdrop-filter: blur(10px);
}

.result-card.error {
  border-color: rgba(239, 68, 68, 0.3);
  background: rgba(239, 68, 68, 0.05);
}

.result-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.result-icon {
  font-size: 32px;
}

.result-info {
  flex: 1 1;
}

.result-info h4 {
  color: white;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.result-info p {
  color: #9ca3af;
  font-size: 13px;
}

.protection-badge {
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.protection-badge.qr {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  border: 1px solid rgba(59, 130, 246, 0.3);
}

.protection-badge.owner_key {
  background: rgba(168, 85, 247, 0.1);
  color: #a855f7;
  border: 1px solid rgba(168, 85, 247, 0.3);
}

.result-error {
  color: #ef4444;
  font-size: 14px;
  padding: 12px;
  background: rgba(239, 68, 68, 0.1);
  border-radius: 8px;
}

.result-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-item label {
  display: block;
  color: #9ca3af;
  font-size: 12px;
  margin-bottom: 4px;
}

.copyable {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.05);
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.copyable code {
  flex: 1 1;
  color: white;
  font-size: 13px;
  font-family: 'Courier New', monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copyable button {
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: #3b82f6;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.copyable button:hover {
  background: rgba(59, 130, 246, 0.2);
}

.results-actions {
  text-align: center;
}

.error-message {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #ef4444;
  padding: 16px;
  border-radius: 12px;
  margin: 16px 0;
  text-align: center;
}

@media (max-width: 768px) {
  .protection-actions {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }

  .results-grid {
    grid-template-columns: 1fr;
  }
}

/* ============================================================
   COMPACT DESKTOP SIZING
   The original values (64px icons, 32px headings, 48px paddings)
   were built for a phone and blew up on desktop — oversized text,
   wasted space, and long scrolling. This layer tightens type and
   spacing and centres the flows in a readable column so the upload
   and media-config screens fit without a scroll, matching the app.
   ============================================================ */

/* Centre each flow in a readable column instead of full-bleed. */
.file-selection-view,
.protection-setup-view,
.upload-progress-view,
.upload-results-view {
  max-width: 860px;
  margin: 0 auto;
}
.upload-results-view { max-width: 1040px; }

/* Upload intro header */
.upload-header { margin-bottom: 16px; }
.upload-header .header-icon { font-size: 40px; margin-bottom: 6px; }
.upload-header h2 { font-size: 22px; margin-bottom: 4px; }
.upload-header p { font-size: 13.5px; }

/* Protection-options info box */
.info-box { padding: 14px 16px; margin-bottom: 14px; }
.info-box h4 { font-size: 14px; margin-bottom: 8px; }
.info-items { gap: 8px 16px; }
.info-item { font-size: 12.5px; gap: 8px; }
.info-item .info-icon { font-size: 16px; }

/* Drop zone */
.drop-zone { padding: 22px 20px; margin-bottom: 12px; }
.drop-zone-content .drop-icon { font-size: 38px; margin-bottom: 6px; }
.drop-zone-content h3 { font-size: 16px; margin-bottom: 2px; }
.drop-zone-content p { font-size: 13px; }
.drop-zone-content .drop-hint { font-size: 12px; }

/* Selected file tiles */
.files-grid { grid-template-columns: repeat(auto-fill, minmax(118px, 1fr)); gap: 12px; }
.file-item { padding: 10px; }
.file-icon { font-size: 30px; }
.file-name { font-size: 12px; }
.file-size { font-size: 11px; }

.file-info { padding: 12px 14px; margin-bottom: 14px; }
.file-info p { font-size: 12.5px; }
.btn-upload { padding: 12px 24px; font-size: 15px; }

/* ---- Media config (protection setup) ---- */
.protection-setup-view h2 { font-size: 22px; margin-bottom: 2px; }
.protection-setup-view .header-icon { font-size: 32px; margin-bottom: 6px; }
.subtitle { font-size: 13px; margin-bottom: 16px; }

.protection-type-tabs { gap: 12px; margin-bottom: 16px; }
.protection-tab { padding: 14px; gap: 12px; }
.tab-icon { font-size: 28px; }
.tab-content h3 { font-size: 15px; }
.tab-content p { font-size: 12.5px; }

.preview-container { margin: 16px 0; padding: 14px; }
.preview-placeholder { padding: 32px 20px; }
.preview-placeholder span { font-size: 40px; margin-bottom: 8px; }
.preview-placeholder p { font-size: 13.5px; }

.option-group { padding: 14px 16px; margin-bottom: 14px; }
.option-group h3 { font-size: 15px; margin-bottom: 10px; }
.option-header { margin-bottom: 10px; }

.position-grid { grid-template-columns: repeat(auto-fit, minmax(96px, 1fr)); gap: 10px; }
.position-btn { padding: 12px; gap: 6px; }
.position-icon { font-size: 22px; }
.position-label { font-size: 12px; }

.error-correction-grid { grid-template-columns: repeat(auto-fit, minmax(84px, 1fr)); gap: 10px; }
.ec-btn { padding: 12px; }

.color-selection { grid-template-columns: repeat(auto-fit, minmax(168px, 1fr)); gap: 12px; }
.color-btn { padding: 14px; gap: 12px; }
.color-preview { width: 44px; height: 44px; font-size: 18px; }
.color-name { font-size: 14px; }

.protection-summary { padding: 14px 16px; margin-bottom: 14px; }
.protection-summary h4 { font-size: 15px; margin-bottom: 10px; }
.summary-items { gap: 10px; }
.summary-icon { font-size: 20px; }

.protection-actions { gap: 12px; }
.btn-primary, .btn-secondary { padding: 12px 24px; font-size: 15px; min-width: 160px; }

/* Results screen */
.upload-results-view { padding: 8px 0 24px; }
.results-header { margin-bottom: 20px; }
.results-header h2 { font-size: 22px; }
.results-header p { font-size: 13.5px; }
.result-icon { font-size: 26px; }`, "",{"version":3,"sources":["webpack://./src/styles/Upload.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;EACE,mFAAmF;EACnF,iBAAiB;AACnB;;AAEA;;;;EAIE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qCAAqC;EACrC,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;;;;;iEAOiE;;AAEjE,iEAAiE;AACjE;;;;EAIE,gBAAgB;EAChB,cAAc;AAChB;AACA,uBAAuB,iBAAiB,EAAE;;AAE1C,wBAAwB;AACxB,iBAAiB,mBAAmB,EAAE;AACtC,8BAA8B,eAAe,EAAE,kBAAkB,EAAE;AACnE,oBAAoB,eAAe,EAAE,kBAAkB,EAAE;AACzD,mBAAmB,iBAAiB,EAAE;;AAEtC,gCAAgC;AAChC,YAAY,kBAAkB,EAAE,mBAAmB,EAAE;AACrD,eAAe,eAAe,EAAE,kBAAkB,EAAE;AACpD,cAAc,aAAa,EAAE;AAC7B,aAAa,iBAAiB,EAAE,QAAQ,EAAE;AAC1C,wBAAwB,eAAe,EAAE;;AAEzC,cAAc;AACd,aAAa,kBAAkB,EAAE,mBAAmB,EAAE;AACtD,gCAAgC,eAAe,EAAE,kBAAkB,EAAE;AACrE,wBAAwB,eAAe,EAAE,kBAAkB,EAAE;AAC7D,uBAAuB,eAAe,EAAE;AACxC,gCAAgC,eAAe,EAAE;;AAEjD,wBAAwB;AACxB,cAAc,4DAA4D,EAAE,SAAS,EAAE;AACvF,aAAa,aAAa,EAAE;AAC5B,aAAa,eAAe,EAAE;AAC9B,aAAa,eAAe,EAAE;AAC9B,aAAa,eAAe,EAAE;;AAE9B,aAAa,kBAAkB,EAAE,mBAAmB,EAAE;AACtD,eAAe,iBAAiB,EAAE;AAClC,cAAc,kBAAkB,EAAE,eAAe,EAAE;;AAEnD,8CAA8C;AAC9C,4BAA4B,eAAe,EAAE,kBAAkB,EAAE;AACjE,sCAAsC,eAAe,EAAE,kBAAkB,EAAE;AAC3E,YAAY,eAAe,EAAE,mBAAmB,EAAE;;AAElD,wBAAwB,SAAS,EAAE,mBAAmB,EAAE;AACxD,kBAAkB,aAAa,EAAE,SAAS,EAAE;AAC5C,YAAY,eAAe,EAAE;AAC7B,kBAAkB,eAAe,EAAE;AACnC,iBAAiB,iBAAiB,EAAE;;AAEpC,qBAAqB,cAAc,EAAE,aAAa,EAAE;AACpD,uBAAuB,kBAAkB,EAAE;AAC3C,4BAA4B,eAAe,EAAE,kBAAkB,EAAE;AACjE,yBAAyB,iBAAiB,EAAE;;AAE5C,gBAAgB,kBAAkB,EAAE,mBAAmB,EAAE;AACzD,mBAAmB,eAAe,EAAE,mBAAmB,EAAE;AACzD,iBAAiB,mBAAmB,EAAE;;AAEtC,iBAAiB,0DAA0D,EAAE,SAAS,EAAE;AACxF,gBAAgB,aAAa,EAAE,QAAQ,EAAE;AACzC,iBAAiB,eAAe,EAAE;AAClC,kBAAkB,eAAe,EAAE;;AAEnC,yBAAyB,0DAA0D,EAAE,SAAS,EAAE;AAChG,UAAU,aAAa,EAAE;;AAEzB,mBAAmB,2DAA2D,EAAE,SAAS,EAAE;AAC3F,aAAa,aAAa,EAAE,SAAS,EAAE;AACvC,iBAAiB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AAC7D,cAAc,eAAe,EAAE;;AAE/B,sBAAsB,kBAAkB,EAAE,mBAAmB,EAAE;AAC/D,yBAAyB,eAAe,EAAE,mBAAmB,EAAE;AAC/D,iBAAiB,SAAS,EAAE;AAC5B,gBAAgB,eAAe,EAAE;;AAEjC,sBAAsB,SAAS,EAAE;AACjC,+BAA+B,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAEtF,mBAAmB;AACnB,uBAAuB,mBAAmB,EAAE;AAC5C,kBAAkB,mBAAmB,EAAE;AACvC,qBAAqB,eAAe,EAAE;AACtC,oBAAoB,iBAAiB,EAAE;AACvC,eAAe,eAAe,EAAE","sourcesContent":["/* Upload.css - Dark Theme to match DemoDashboard */\n\nbody {\n  background: linear-gradient(to bottom right, #2b2b2b 0%, #141414 50%, #000000 100%);\n  min-height: 100vh;\n}\n\n.file-selection-view,\n.protection-setup-view,\n.upload-progress-view,\n.upload-results-view {\n  color: white;\n  background: transparent;\n}\n\n.upload-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.upload-header .header-icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n}\n\n.upload-header h2 {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 12px;\n  color: #a78bfa;\n}\n\n.upload-header p {\n  color: #d1d5db;\n  font-size: 16px;\n}\n\n.info-box {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 32px;\n  backdrop-filter: blur(10px);\n}\n\n.info-box h4 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: white;\n}\n\n.info-items {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 12px;\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #d1d5db;\n  font-size: 14px;\n}\n\n.info-item .info-icon {\n  font-size: 24px;\n}\n\n.drop-zone {\n  border: 2px dashed rgba(255, 255, 255, 0.3);\n  border-radius: 16px;\n  padding: 48px 24px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: rgba(0, 0, 0, 0.3);\n  margin-bottom: 24px;\n  backdrop-filter: blur(10px);\n}\n\n.drop-zone:hover {\n  border-color: rgba(168, 85, 247, 0.5);\n  background: rgba(168, 85, 247, 0.05);\n  transform: translateY(-2px);\n}\n\n.drop-zone.dragging {\n  border-color: #a855f7;\n  background: rgba(168, 85, 247, 0.15);\n  box-shadow: 0 8px 32px rgba(168, 85, 247, 0.2);\n}\n\n.drop-zone-content .drop-icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n}\n\n.drop-zone-content h3 {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: white;\n}\n\n.drop-zone-content p {\n  color: #9ca3af;\n  margin-bottom: 4px;\n}\n\n.drop-zone-content .drop-hint {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.selected-files .files-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  color: white;\n  font-weight: 600;\n}\n\n.clear-btn {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  padding: 6px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.clear-btn:hover {\n  background: rgba(239, 68, 68, 0.2);\n}\n\n.files-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.file-item {\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  padding: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(5px);\n}\n\n.file-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.25);\n  transform: translateY(-2px);\n}\n\n.file-item.active {\n  border-color: #a855f7;\n  background: rgba(168, 85, 247, 0.15);\n  box-shadow: 0 4px 16px rgba(168, 85, 247, 0.2);\n}\n\n.file-preview {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1;\n  border-radius: 8px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.03);\n  margin-bottom: 8px;\n}\n\n.file-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.file-icon {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 48px;\n}\n\n.remove-btn {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: rgba(239, 68, 68, 0.9);\n  color: white;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.remove-btn:hover {\n  background: #dc2626;\n  transform: scale(1.1);\n}\n\n.file-name {\n  font-size: 13px;\n  color: white;\n  font-weight: 500;\n  margin-bottom: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.file-size {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.edit-btn {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  padding: 4px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s ease;\n}\n\n.edit-btn:hover {\n  background: rgba(59, 130, 246, 0.2);\n}\n\n.add-more {\n  color: #3b82f6;\n  font-size: 14px;\n  cursor: pointer;\n  margin-top: 12px;\n}\n\n.add-more:hover {\n  text-decoration: underline;\n}\n\n.file-info {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 16px;\n  margin-bottom: 24px;\n  backdrop-filter: blur(10px);\n}\n\n.file-info p {\n  color: #d1d5db;\n  font-size: 14px;\n  margin: 4px 0;\n}\n\n.btn-upload {\n  width: 100%;\n  background: linear-gradient(135deg, #a855f7 0%, #3b82f6 100%);\n  color: white;\n  border: none;\n  padding: 16px 32px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 16px rgba(168, 85, 247, 0.3);\n}\n\n.btn-upload:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(168, 85, 247, 0.4);\n}\n\n.protection-setup-view h2 {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: #a78bfa;\n  text-align: center;\n}\n\n.protection-setup-view .header-icon {\n  text-align: center;\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.subtitle {\n  text-align: center;\n  color: #d1d5db;\n  font-size: 16px;\n  margin-bottom: 32px;\n  margin-top: -4px;\n}\n\n.protection-type-tabs {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.protection-tab {\n  background: rgba(0, 0, 0, 0.3);\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 24px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  backdrop-filter: blur(10px);\n}\n\n.protection-tab:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(59, 130, 246, 0.4);\n  transform: translateY(-2px);\n}\n\n.protection-tab.active {\n  background: rgba(59, 130, 246, 0.15);\n  border-color: #3b82f6;\n  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.2);\n}\n\n.tab-icon {\n  font-size: 48px;\n}\n\n.tab-content h3 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 4px;\n  color: white;\n}\n\n.tab-content p {\n  font-size: 14px;\n  color: #9ca3af;\n}\n\n.preview-container {\n  margin: 32px 0;\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 24px;\n  backdrop-filter: blur(10px);\n}\n\n.preview-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 32px;\n  color: #9ca3af;\n}\n\n.preview-placeholder span {\n  font-size: 64px;\n  margin-bottom: 16px;\n}\n\n.preview-placeholder p {\n  font-size: 16px;\n  margin: 4px 0;\n}\n\n.placeholder-hint {\n  font-size: 14px !important;\n  color: #6b7280 !important;\n}\n\n.option-group {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n  backdrop-filter: blur(10px);\n}\n\n.option-group h3 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: white;\n}\n\n.option-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.option-header h3 {\n  margin-bottom: 0;\n}\n\n.option-header span {\n  color: #3b82f6;\n  font-weight: 600;\n}\n\n.position-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 12px;\n}\n\n.position-btn {\n  background: rgba(0, 0, 0, 0.3);\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  backdrop-filter: blur(5px);\n}\n\n.position-btn:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n.position-btn.selected {\n  background: rgba(59, 130, 246, 0.2);\n  border-color: #3b82f6;\n  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.3);\n}\n\n.position-icon {\n  font-size: 32px;\n}\n\n.position-label {\n  font-size: 13px;\n  color: #d1d5db;\n}\n\n.slider {\n  width: 100%;\n  height: 8px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.1);\n  outline: none;\n  margin: 16px 0;\n}\n\n.slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #a855f7 0%, #3b82f6 100%);\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(168, 85, 247, 0.4);\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #a855f7 0%, #3b82f6 100%);\n  cursor: pointer;\n  border: none;\n  box-shadow: 0 2px 8px rgba(168, 85, 247, 0.4);\n}\n\n.slider-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #9ca3af;\n  margin-top: 8px;\n}\n\n.helper-text {\n  font-size: 14px;\n  color: #9ca3af;\n  margin-top: 8px;\n}\n\n.error-correction-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n  gap: 12px;\n}\n\n.ec-btn {\n  background: rgba(0, 0, 0, 0.3);\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  color: white;\n  backdrop-filter: blur(5px);\n}\n\n.ec-btn:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n.ec-btn.selected {\n  background: rgba(59, 130, 246, 0.2);\n  border-color: #3b82f6;\n  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.3);\n}\n\n.ec-level {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.color-selection {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.color-btn {\n  background: rgba(0, 0, 0, 0.3);\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  backdrop-filter: blur(10px);\n}\n\n.color-btn:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n.color-btn.selected {\n  background: rgba(59, 130, 246, 0.2);\n  border-color: #3b82f6;\n  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);\n}\n\n.color-preview {\n  width: 60px;\n  height: 60px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.color-preview.white {\n  background: white;\n  color: black;\n}\n\n.color-preview.black {\n  background: black;\n  color: white;\n}\n\n.color-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.color-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n}\n\n.color-desc {\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.protection-summary {\n  background: rgba(16, 185, 129, 0.1);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.protection-summary h4 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: #10b981;\n}\n\n.summary-items {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.summary-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.summary-icon {\n  font-size: 24px;\n}\n\n.summary-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.summary-content strong {\n  color: white;\n  font-size: 15px;\n}\n\n.summary-content span {\n  color: #d1d5db;\n  font-size: 13px;\n}\n\n.protection-actions {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.btn-primary {\n  flex: 1;\n  min-width: 200px;\n  background: linear-gradient(135deg, #a855f7 0%, #3b82f6 100%);\n  color: white;\n  border: none;\n  padding: 16px 32px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 16px rgba(168, 85, 247, 0.3);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(168, 85, 247, 0.4);\n}\n\n.btn-secondary {\n  flex: 1;\n  min-width: 200px;\n  background: rgba(255, 255, 255, 0.05);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 16px 32px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.upload-progress-view {\n  text-align: center;\n  padding: 64px 32px;\n}\n\n.progress-icon {\n  font-size: 64px;\n  margin-bottom: 24px;\n}\n\n.upload-progress-view h2 {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 16px;\n  color: #a78bfa;\n}\n\n.status-text {\n  color: #d1d5db;\n  font-size: 16px;\n  margin-bottom: 24px;\n}\n\n.progress-bar-container {\n  width: 100%;\n  max-width: 500px;\n  height: 12px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  overflow: hidden;\n  margin: 0 auto 16px;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #a855f7 0%, #3b82f6 100%);\n  transition: width 0.3s ease;\n  border-radius: 6px;\n}\n\n.progress-text {\n  color: #3b82f6;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.upload-results-view {\n  padding: 32px;\n}\n\n.results-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.results-header h2 {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: #a78bfa;\n}\n\n.results-header p {\n  color: #d1d5db;\n  font-size: 16px;\n}\n\n.results-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.result-card {\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 20px;\n  backdrop-filter: blur(10px);\n}\n\n.result-card.error {\n  border-color: rgba(239, 68, 68, 0.3);\n  background: rgba(239, 68, 68, 0.05);\n}\n\n.result-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.result-icon {\n  font-size: 32px;\n}\n\n.result-info {\n  flex: 1;\n}\n\n.result-info h4 {\n  color: white;\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.result-info p {\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n.protection-badge {\n  padding: 4px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.protection-badge.qr {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n  border: 1px solid rgba(59, 130, 246, 0.3);\n}\n\n.protection-badge.owner_key {\n  background: rgba(168, 85, 247, 0.1);\n  color: #a855f7;\n  border: 1px solid rgba(168, 85, 247, 0.3);\n}\n\n.result-error {\n  color: #ef4444;\n  font-size: 14px;\n  padding: 12px;\n  background: rgba(239, 68, 68, 0.1);\n  border-radius: 8px;\n}\n\n.result-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detail-item label {\n  display: block;\n  color: #9ca3af;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.copyable {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.copyable code {\n  flex: 1;\n  color: white;\n  font-size: 13px;\n  font-family: 'Courier New', monospace;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.copyable button {\n  background: rgba(59, 130, 246, 0.1);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  color: #3b82f6;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.copyable button:hover {\n  background: rgba(59, 130, 246, 0.2);\n}\n\n.results-actions {\n  text-align: center;\n}\n\n.error-message {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #ef4444;\n  padding: 16px;\n  border-radius: 12px;\n  margin: 16px 0;\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .protection-actions {\n    flex-direction: column;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    width: 100%;\n  }\n\n  .results-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ============================================================\n   COMPACT DESKTOP SIZING\n   The original values (64px icons, 32px headings, 48px paddings)\n   were built for a phone and blew up on desktop — oversized text,\n   wasted space, and long scrolling. This layer tightens type and\n   spacing and centres the flows in a readable column so the upload\n   and media-config screens fit without a scroll, matching the app.\n   ============================================================ */\n\n/* Centre each flow in a readable column instead of full-bleed. */\n.file-selection-view,\n.protection-setup-view,\n.upload-progress-view,\n.upload-results-view {\n  max-width: 860px;\n  margin: 0 auto;\n}\n.upload-results-view { max-width: 1040px; }\n\n/* Upload intro header */\n.upload-header { margin-bottom: 16px; }\n.upload-header .header-icon { font-size: 40px; margin-bottom: 6px; }\n.upload-header h2 { font-size: 22px; margin-bottom: 4px; }\n.upload-header p { font-size: 13.5px; }\n\n/* Protection-options info box */\n.info-box { padding: 14px 16px; margin-bottom: 14px; }\n.info-box h4 { font-size: 14px; margin-bottom: 8px; }\n.info-items { gap: 8px 16px; }\n.info-item { font-size: 12.5px; gap: 8px; }\n.info-item .info-icon { font-size: 16px; }\n\n/* Drop zone */\n.drop-zone { padding: 22px 20px; margin-bottom: 12px; }\n.drop-zone-content .drop-icon { font-size: 38px; margin-bottom: 6px; }\n.drop-zone-content h3 { font-size: 16px; margin-bottom: 2px; }\n.drop-zone-content p { font-size: 13px; }\n.drop-zone-content .drop-hint { font-size: 12px; }\n\n/* Selected file tiles */\n.files-grid { grid-template-columns: repeat(auto-fill, minmax(118px, 1fr)); gap: 12px; }\n.file-item { padding: 10px; }\n.file-icon { font-size: 30px; }\n.file-name { font-size: 12px; }\n.file-size { font-size: 11px; }\n\n.file-info { padding: 12px 14px; margin-bottom: 14px; }\n.file-info p { font-size: 12.5px; }\n.btn-upload { padding: 12px 24px; font-size: 15px; }\n\n/* ---- Media config (protection setup) ---- */\n.protection-setup-view h2 { font-size: 22px; margin-bottom: 2px; }\n.protection-setup-view .header-icon { font-size: 32px; margin-bottom: 6px; }\n.subtitle { font-size: 13px; margin-bottom: 16px; }\n\n.protection-type-tabs { gap: 12px; margin-bottom: 16px; }\n.protection-tab { padding: 14px; gap: 12px; }\n.tab-icon { font-size: 28px; }\n.tab-content h3 { font-size: 15px; }\n.tab-content p { font-size: 12.5px; }\n\n.preview-container { margin: 16px 0; padding: 14px; }\n.preview-placeholder { padding: 32px 20px; }\n.preview-placeholder span { font-size: 40px; margin-bottom: 8px; }\n.preview-placeholder p { font-size: 13.5px; }\n\n.option-group { padding: 14px 16px; margin-bottom: 14px; }\n.option-group h3 { font-size: 15px; margin-bottom: 10px; }\n.option-header { margin-bottom: 10px; }\n\n.position-grid { grid-template-columns: repeat(auto-fit, minmax(96px, 1fr)); gap: 10px; }\n.position-btn { padding: 12px; gap: 6px; }\n.position-icon { font-size: 22px; }\n.position-label { font-size: 12px; }\n\n.error-correction-grid { grid-template-columns: repeat(auto-fit, minmax(84px, 1fr)); gap: 10px; }\n.ec-btn { padding: 12px; }\n\n.color-selection { grid-template-columns: repeat(auto-fit, minmax(168px, 1fr)); gap: 12px; }\n.color-btn { padding: 14px; gap: 12px; }\n.color-preview { width: 44px; height: 44px; font-size: 18px; }\n.color-name { font-size: 14px; }\n\n.protection-summary { padding: 14px 16px; margin-bottom: 14px; }\n.protection-summary h4 { font-size: 15px; margin-bottom: 10px; }\n.summary-items { gap: 10px; }\n.summary-icon { font-size: 20px; }\n\n.protection-actions { gap: 12px; }\n.btn-primary, .btn-secondary { padding: 12px 24px; font-size: 15px; min-width: 160px; }\n\n/* Results screen */\n.upload-results-view { padding: 8px 0 24px; }\n.results-header { margin-bottom: 20px; }\n.results-header h2 { font-size: 22px; }\n.results-header p { font-size: 13.5px; }\n.result-icon { font-size: 26px; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
